export default function env(key) {
  return process.env[key];
}
